import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Paragraph } from '@fs/zion-ui'
import { Trans } from 'react-i18next/icu.macro'

import { useSiteLink } from '../hooks'

const SignupButton = () => {
  const { t } = useTranslation()
  const signupLink = useSiteLink({ pathname: '/identity/signup/' })
  return (
    <Button emphasis="low" to={signupLink} linkName="Sign Up" id="create-account">
      {t('sign-up.action', 'Sign Up')}
    </Button>
  )
}

export default function SignUpLink() {
  return (
    <Paragraph size="sm" centered>
      <Trans
        i18nKey="new-to-familysearch.label"
        defaults="New to FamilySearch? <SignupButton>Sign Up</SignupButton>."
        components={{
          SignupButton: <SignupButton />,
        }}
      />
    </Paragraph>
  )
}
